import {screenLinking, Routes} from 'navigation/Routes';

function DFSSearch(source: any, target: any) {
  if (!source || typeof source !== 'object') {
    return false;
  }

  // Check if the target is directly inside source
  if (source.screens && target in source.screens) {
    return true;
  }

  // Recursively search in nested objects
  for (const key in source.screens) {
    if (DFSSearch(source.screens[key], target)) {
      return true;
    }
  }

  return false;
}

export function isParentOf(currentRoute: any, parentRoute: any) {
  // define root
  const INSIDE_STACK = Routes.INSIDE_STACK;
  const root = screenLinking[INSIDE_STACK].screens[parentRoute];

  if (!root) {
    return false;
  }

  // base case when current and parent route is same
  if (currentRoute === parentRoute) {
    return true;
  }

  return DFSSearch(root, currentRoute);
}
